<template>
  <div class="report-view">
    <div class="container">
      <NavigationBar />
    </div>

    <!-- Download modal (opens from "ИЗТЕГЛИ ДОКЛАДА" buttons) -->
    <div
      v-if="isDownloadModalOpen"
      class="report-download-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label="Изтегляне на доклада"
      @click.self="closeDownloadModal"
    >
      <div class="report-download-modal">
        <button class="report-download-modal__close" type="button" @click="closeDownloadModal" aria-label="Close">
          <ModalCloseBtn />
        </button>

        <div class="report-download-modal__body">
          <label class="report-download-modal__label" for="reportDownloadEmail">Email</label>
          <input
            id="reportDownloadEmail"
            class="report-download-modal__input"
            type="email"
            inputmode="email"
            autocomplete="email"
            placeholder="name@example.com"
            v-model.trim="downloadEmail"
          />

          <button
            class="report-download-btn report-download-btn--modal"
            :class="{ 'report-download-btn--disabled': !isDownloadEmailValid }"
            type="button"
            :disabled="!isDownloadEmailValid"
            @click="downloadReportPdf"
          >
            ИЗТЕГЛИ
          </button>
        </div>
      </div>
    </div>

    <!-- Hero Section -->
    <section class="hero-section mt-4 mb-5">
      <div class="container-fluid" style="padding: 0 5%;">
        <div class="row g-0 align-items-center hero-banner" style="background-image: url('/static/mom_img.png'); background-size: 100% 100%; background-position: center; background-repeat: no-repeat;">
          <div class="col-lg-12 hero-content-col">
             <div class="hero-content-inner">
                <h1>
                  <span class="fixed-line">Всяка втора майка се чувства</span>
                  <span class="fixed-line">самотна и неразбрана.</span>
                  <span class="fixed-line">А ти как си?</span>
                </h1>
                
                <div class="report-tag mt-4">
                  Доклад от проучването на Мъмфидънт
                </div>
                
                <p class="description mt-3">
                  Факти за психичното здраве на майките с деца от 0 до 3г,<br>които засягат цялото ни общество, но често остават невидими.
                </p>
                
                <button class="report-download-btn mt-4" type="button" @click="openDownloadModal">ИЗТЕГЛИ ДОКЛАДА</button>
             </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Stats Section -->
    <section class="stats-section">
      <div class="container-fluid text-center stats-bubble">
        <h2 class="mb-5 report-hero-title-style">Щастливите и трудни моменти на<br>майчинството в България в числа</h2>
        
        <div class="row justify-content-center stats-grid">
          <div class="col-6 col-md-3 stat-item">
            <div class="stat-value text-purple">63%</div>
            <div class="stat-desc">от майките показват високи<br>нива на щастие, но<br>половината определят<br>майчинството като трудно</div>
          </div>
          <div class="col-6 col-md-3 stat-item">
            <div class="stat-value text-pink tight-spacing">1 от 4</div>
            <div class="stat-desc">майки изпитват често или<br>много често тревожност<br>и депресивни мисли</div>
          </div> 
          <div class="col-6 col-md-3 stat-item">
            <div class="stat-value text-red">23%</div>
            <div class="stat-desc">от майките са имали натрапливи<br>мисли за самоубийство</div>
          </div>
          <div class="col-6 col-md-3 stat-item">
            <div class="stat-value text-light-pink">44%</div>
            <div class="stat-desc">от майките не желаят<br>да имат повече деца,<br>защото им е много<br>трудно напоследък</div>
          </div>
        </div>

        <div class="stats-footer mt-5">
          <div class="dedication">Този доклад е посветен на всички майки</div>
          <div class="footer-line">В него разказваме за двуликостта на майчинството: за хубавите и за трудните негови страни.</div>
          <div class="footer-line">Говорим за любовта, топлината, близостта и щастието, но и за безсънието, умората, стреса, тъгата, самокритиката и депресивността.</div>
          <div class="footer-line">Той е резултат от онлайн проучване, което Мъмфидънт проведе сред българските майки с деца между 0 и 7 години през периода</div>
          <div class="footer-line">10.06. – 10.09.2025г. Проучването е изготвено от социални учени от БАН и практикуващи психолози.</div>
        </div>
        
        <button class="report-download-btn mt-5" type="button" @click="openDownloadModal">ИЗТЕГЛИ ДОКЛАДА</button>
      </div>
    </section>

    <NumberedAppSupportSection />

    <!-- Survey Box (hidden for now; keep code to enable later) -->
    <section class="survey-box-section my-5" v-if="false">
       <div class="container text-center">
         <div class="survey-img-wrapper">
            <div class="survey-img survey-box-content">
              <div class="survey-box-bg">
                <p class="survey-box-top-text">
                  Всички включили се в проучването получават <span class="survey-box-highlight">тримесечен неограничен достъп</span> до приложението Momfident, което цели да даде психологическа подкрепа на вас и на други майки като вас.
                </p>
                <div class="survey-box-card">
                  <h3 class="survey-box-heading">Какво представлява приложението Momfident?</h3>
                  <p class="survey-box-body">Momfident е виртуален психологически асистент, създаден с помощта на изкуствен интелект и проверени научни източници.</p>
                  <p class="survey-box-body">Това е инструмент за самопомощ, който предоставя емоционална подкрепа и научно обоснована информация по теми като психично здраве, родителство, връзка с детето и грижа за себе си – с фокус върху майки с деца от 0 до 3 години. Не замества терапия, но ви помага със стратегии за справяне и съдържание, адаптирано към вашите нужди.</p>
                  <a href="/download" class="survey-box-btn">СВАЛИ ПРИЛОЖЕНИЕТО</a>
                </div>
              </div>
            </div>
         </div>
       </div>
    </section>

    <!-- Quotes Section -->
    <section class="quotes-section container-fluid">
       <!-- Background Decorations -->
       <img src="/static/Vector 5.png" alt="" class="bg-decoration left-deco" />
       <img src="/static/Vector 6.png" alt="" class="bg-decoration right-deco" />

       <div class="quotes-container">
         
         <!-- Heading -->
         <div class="heading-wrapper text-center mb-5">
            <h2 class="heading-text report-hero-title-style mb-0">Какво значи трудно?</h2>
         </div>
           
         <!-- Quotes Grid -->
         <div class="quotes-grid">
            <!-- Quote 1: Left Top -->
            <div class="quote-item item-1">
              <img src="/static/firstquote.png" alt="Quote 1" class="img-fluid" />
            </div>
            
            <!-- Quote 2: Right Top (offset down) -->
            <div class="quote-item item-2">
              <img src="/static/secondquote.png" alt="Quote 2" class="img-fluid" />
            </div>
            
            <!-- Quote 3: Right Center (offset left) -->
            <div class="quote-item item-3">
              <img src="/static/quotefour.png" alt="Quote 3" class="img-fluid" />
            </div>
            
            <!-- Quote 4: Left Bottom -->
            <div class="quote-item item-4">
              <img src="/static/thirdquote.png" alt="Quote 4" class="img-fluid" />
            </div>
         </div>

         <!-- Footer Text & Button -->
         <div class="section-footer text-center mt-5">
           <p class="footer-text">
             Научи повече какво значи трудно и как наистина се чувстват младите майките в България
           </p>
           <img
             src="/static/download_doklad.png"
             alt="Download Report"
             class="cta-img-btn mt-3"
             role="button"
             tabindex="0"
             @click="openDownloadModal"
             @keydown.enter.prevent="openDownloadModal"
             @keydown.space.prevent="openDownloadModal"
           />
         </div>
       </div>
    </section>

    <!-- Partners Section -->
    <section class="partners-section container my-5">
      <p class="text-start mb-5 partners-heading">Това проучване се осъществява със съдействието на:</p>
      
      <div class="partners-grid-layout">
        <!-- Row 1 -->
        <div class="partner-cell"><img src="/static/report_preview_logos/Radostnamama.png" class="partner-logo" alt="Radostna Mama"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/Misiqmama.png" class="partner-logo" alt="Misia Mama"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/Framar.png" class="partner-logo" alt="Framar"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/IPHS.png" class="partner-logo" alt="IPHS"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/SofiaTechPark.png" class="partner-logo" alt="Sofia Tech Park"></div>

        <!-- Row 2 -->
        <div class="partner-cell"><img src="/static/report_preview_logos/BusinessLab.png" class="partner-logo" alt="Business Lab"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/ParentsAcademy.png" class="partner-logo" alt="Parent Academy"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/MomGotAJob.png" class="partner-logo" alt="Mom got a job"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/Rinker.png" class="partner-logo" alt="Rinker"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/Momvy.png" class="partner-logo" alt="Momvy"></div>

        <!-- Row 3 -->
        <div class="partner-cell"><img src="/static/report_preview_logos/MomCode.png" class="partner-logo" alt="Mom Code"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/MomTalksMoney.png" class="partner-logo" alt="Mama Talks Money"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/VedriMami.png" class="partner-logo" alt="Vedri Mami"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/RentABaba.png" class="partner-logo" alt="Rent a Baba"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/SelfLove.png" class="partner-logo" alt="Self Love"></div>

        <!-- Row 4 -->
        <div class="partner-cell"><img src="/static/report_preview_logos/Multicollective.png" class="partner-logo" alt="Multi Lux"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/KaterinaAtias.png" class="partner-logo" alt="Katerina Atias"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/FutureFemales.png" class="partner-logo" alt="Future Females"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/EkaterinaKaravelova.png" class="partner-logo" alt="Ekaterina Karavelova"></div>
        <div class="partner-cell"><img src="/static/report_preview_logos/Mammi.png" class="partner-logo" alt="Mammi"></div>
        
        <!-- Row 5 -->
        <div class="partner-cell"><img src="/static/report_preview_logos/RealFood.png" class="partner-logo" alt="Real Food"></div>
      </div>
    </section>

    <FooterComponent :show-logos="false" />
  </div>
</template>

<script setup>
import NavigationBar from '@/components/NavigationBar.vue';
import FooterComponent from '@/components/Components/FooterComponent.vue';
import ModalCloseBtn from '@/components/Components/ModalComponent/ModalCloseBtn.vue';
import NumberedAppSupportSection from '@/components/Components/Report/NumberedAppSupportSection.vue';
import { computed, ref, watch } from 'vue';

const isDownloadModalOpen = ref(false);
const downloadEmail = ref('');
const reportPdfUrl = '/Report_maternity_in_Bulgaria_Momfident.pdf';
const reportPdfFilename = 'Report_maternity_in_Bulgaria_Momfident.pdf';
const formspreeEndpoint = 'https://formspree.io/f/mykdlypw';


const isDownloadEmailValid = computed(() => {
  const email = downloadEmail.value || '';
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
});

async function downloadReportPdf() {
  if (!isDownloadEmailValid.value) return;

  const email = downloadEmail.value;

  // Send email to Formspree via POST (form submission)
  try {
    const formData = new FormData();
    formData.append('email', email);
    await fetch(formspreeEndpoint, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
    });
  } catch (e) {
    // Still trigger download if submission fails (e.g. network error)
    console.warn('Formspree submit failed:', e);
  }

  // Trigger PDF download
  const a = document.createElement('a');
  a.href = reportPdfUrl;
  a.download = reportPdfFilename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();

  closeDownloadModal();
}

function openDownloadModal() {
  isDownloadModalOpen.value = true;
}

function closeDownloadModal() {
  isDownloadModalOpen.value = false;
  downloadEmail.value = '';
}

watch(isDownloadModalOpen, (open) => {
  // Prevent background scroll when modal is open
  document.body.style.overflow = open ? 'hidden' : '';
});
</script>

<style scoped lang="scss">
@import "~@/assets/scss/fonts.scss";
@import "~@/assets/scss/variables.scss";

.report-view {
  font-family: 'Rubik', sans-serif;
  color: #5a5583;
  position: relative;
  overflow-x: hidden; /* Prevent horizontal scroll from decorations */
}

.bg-decoration-left {
  position: absolute;
  left: 0;
  top: 15%; /* Adjust vertical position */
  z-index: -1;
  max-width: 300px; /* Limit size just in case */
  pointer-events: none;
}

.report-download-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(100, 100, 100, 0.7);
  z-index: 9999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}

.report-download-modal {
  width: 100%;
  max-width: 520px;
  background: #ffffff;
  border-radius: 20px;
  position: relative;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}

.report-download-modal__close {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.report-download-modal__body {
  padding: 28px 28px 26px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}


.report-download-modal__label {
  font-family: $font-regular;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  color: $color-purple;
  margin: 0;
}

.report-download-modal__input {
  width: 100%;
  height: 48px;
  border-radius: 14px;
  border: 2px solid rgba(107, 107, 156, 0.25);
  padding: 0 14px;
  font-family: $font-regular;
  font-size: 14px;
  color: $color-purple;
  outline: none;
}

.report-download-modal__input:focus {
  border-color: rgba(252, 103, 139, 0.85);
  box-shadow: 0 0 0 4px rgba(252, 103, 139, 0.18);
}

.report-download-btn--modal {
  width: 100%;
  max-width: 360px;
  margin: 6px auto 0;
}

.report-download-btn--disabled {
  background: #d7d7e2 !important;
  box-shadow: none !important;
  cursor: not-allowed !important;
  transform: none !important;
}

.report-download-btn--disabled:hover,
.report-download-btn--disabled:active {
  background: #d7d7e2 !important;
  box-shadow: none !important;
  transform: none !important;
}

.report-download-btn--disabled:disabled {
  opacity: 1;
}

.cta-btn {
  background: #fc678b;
  color: white;
  border: none;
  padding: 14px 60px; /* Increased length */
  border-radius: 30px;
  font-weight: 500; /* Not bold (was 700) */
  text-transform: uppercase;
  font-size: 12px; /* Smaller (was 14px) */
  box-shadow: 0 4px 10px rgba(252, 103, 139, 0.4);
  transition: all 0.2s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(252, 103, 139, 0.5);
  }
}

/* Hero */
.hero-section {
  overflow-x: hidden;
}

.hero-banner {
  background-color: #ffeef4;
  background-position: right center;
  background-repeat: no-repeat;
  background-size: auto 100%;
  border-radius: 30px;
  min-height: 550px;
}

.hero-content-col {
  display: flex;
  justify-content: flex-start; /* Aligns content to the left */
  padding-left: 60px; /* Add spacing from left edge */
  padding-right: 20px;
  
  @media (max-width: 992px) {
    justify-content: center;
    padding-right: 15px;
    padding-left: 15px;
    text-align: center;
    margin-bottom: 30px;
  }
}

@media (max-width: 992px) {
  .hero-content-inner h1 {
    font-size: 30px;
  }

  .report-tag {
    font-size: 15px;
  }
}

.hero-content-inner {
  width: 100%;
  max-width: 650px; /* Restrict width */
  padding-left: 40px; /* Add some padding */
  padding-right: 20px;
  padding-top: 0px; /* Move hero text block up more */
  margin-top: -10px;
  
  @media (min-width: 1400px) {
  }
}

.hero-content-inner h1 {
    /* Match HomePrimaryHero h2 ("Достъпна психологическа грижа за всяка майка") */
    font-family: $font-thin; /* Rubik-Light for the same thin look */
    font-size: 50px;
    font-weight: 300;
    line-height: 1;
    color: $color-purple;
    letter-spacing: 0;

    .fixed-line {
      display: block;
      white-space: nowrap;
      word-break: keep-all;
    }
}
  
.hero-content-inner h2 {
    font-size: 40px; /* Reduced from 50px */
    font-weight: 400;
    color: #6B6B9C; /* Updated color */
    margin-bottom: 0;
    line-height: 1;
    letter-spacing: 0;
}
  
.report-tag {
    /* Match HomePrimaryHero h3 ("Премахваме стигмата...") */
  font-family: 'Rubik-Medium';
    font-size: 22px;
    color: $color-purple;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0;
}
  
.hero-content-inner .description {
    /* Match HomePrimaryHero subtitle ("Бъдете сред първите от общността на Momfident") */
    font-family: $font-regular;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: 0;
    color: $color-purple;
}

.hero-content-inner .cta-btn {
    padding: 14px 60px; /* Decreased height slightly */
    font-size: 12px; /* Update hero override to match smaller size req */
    letter-spacing: 0.5px;
    font-family: 'Rubik', sans-serif;
    font-weight: 600; /* Increased weight */
}

.report-download-btn {
  background: $color-pink-dark-2;
  color: #ffffff;
  border: none;
  border-radius: 999px;
  padding: 12px 52px;
  min-width: 260px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: 'Rubik-Light';
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 0;
  box-shadow: 0 4px 12px rgba(252, 103, 139, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

  &:hover {
    background: $color-pink-dark;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(252, 103, 139, 0.45);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 3px 10px rgba(252, 103, 139, 0.35);
  }
}


/* Stats */
.stats-section {
  background: #6c6396; /* Full width background */
  padding: 40px 0 2rem; /* Reduced bottom spacing */
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  
  .stats-bubble {
    /* Removed specific bubble styling as requested */
    padding: 60px 30px 40px 30px; /* Reduced bottom padding */
    max-width: 100%;
    margin: 0 auto;
    background: transparent;
  }

  h2 {
    font-size: 40px; /* Reduced from 50px */
    font-weight: 500; /* Changed from 700 */
    line-height: 1;
    letter-spacing: 0;
    color: #ffffff;
    text-align: center;
  }

  /* Use the same typography as the hero title (except font-size) */
  h2.report-hero-title-style {
    font-family: $font-thin;
    font-weight: 300;
    line-height: 1;
    letter-spacing: 0;
  }
  
  .stat-value {
    font-family: 'Rubik-Black', sans-serif; /* Revert to specific black font */
    font-size: 60px; /* Reduced from 75px */
    line-height: 72px; /* Adjusted line height */
    letter-spacing: 0;
    text-align: center;
    margin-bottom: 15px;
    color: white; /* Ensure visible on purple */
  }

  .tight-spacing {
    word-spacing: -5px; /* Less tight */
    letter-spacing: -0.5px;
  }
  
  .text-purple { color: #ffffff; }
  .text-pink { color: #FF95AA; }
  .text-red { color: #FC678B; }
  .text-light-pink { color: #F9C2D1; }
  
  .stat-value.text-pink + .stat-desc { color: #FF95AA; }
  .stat-value.text-red + .stat-desc { color: #FC678B; }
  .stat-value.text-light-pink + .stat-desc { color: #F9C2D1; }
  
  .stat-desc {
    font-family: 'Rubik', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: 0.6px;
    text-align: center;
    margin-bottom: 5px;
    color: white;
  }

  .dedication {
    font-family: 'Rubik', sans-serif;
    font-weight: 600; /* Bolder */
    font-size: 18px; /* Bigger */
    line-height: 1;
    letter-spacing: 0;
    text-align: center;
    margin-bottom: 30px;
    display: block; /* Ensure block behavior */
  }

  .stats-footer {
    font-family: 'Rubik', sans-serif;
    font-weight: 300;
    font-size: 16px; /* Increased size */
    line-height: 1;
    letter-spacing: 0;
    text-align: center;
    color: #ffffff;
    max-width: 1400px; /* Increased width to prevent wrapping */
    margin: 0 auto;
    
    .footer-line {
      line-height: 1;
      margin-bottom: 8px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  
  .stats-bubble .cta-btn {
    padding: 14px 60px; /* Increased width */
    font-weight: 600; /* Bolder */
  }
}

/* Remove extra gaps between Stats → App support → Quotes on /survey */
.report-view :deep(.app-support) {
  margin-top: 0 !important;
}

/* App Support */
/* moved to ReportAppSupportSection.vue */

/* Survey Box */
.survey-box-section {
  background: #fff;
  
  .survey-img-wrapper {
    position: relative;
    display: inline-block;
    max-width: 960px;
    width: 100%;
    margin-left: 26px;
  }

  .survey-img {
    width: 100%;
    height: auto;
    display: block;
  }

  .survey-box-content {
    width: 100%;
    display: block;
    box-sizing: border-box;
  }

  .survey-box-bg {
    background-color: #FDF1F5;
    border-radius: 40px;
    padding: 20px 40px 22px;
    text-align: center;
  }

  .survey-box-top-text {
    font-family: 'Rubik', sans-serif;
    color: #6B6B9C;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.4;
    margin: 0 0 16px 0;
    max-width: 100%;
  }

  .survey-box-highlight {
    background: linear-gradient(to right, #6B6B9C, #F56C8C);
    color: #FFFFFF;
    border-radius: 8px;
    padding: 3px 10px 4px 10px;
  }

  .survey-box-card {
    background-color: #FFFFFF;
    border-radius: 40px;
    padding: 22px 40px 22px;
    text-align: center;
  }

  .survey-box-heading {
    font-family: 'Rubik', sans-serif;
    color: #6B6B9C;
    font-size: 22px;
    font-weight: 600;
    line-height: 1.3;
    margin: 0 0 14px 0;
  }

  .survey-box-body {
    font-family: 'Rubik', sans-serif;
    color: #6A3C7E;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.45;
    margin: 0 0 10px 0;
  }

  .survey-box-body:last-of-type {
    margin-bottom: 16px;
  }

  .survey-box-btn {
    display: inline-block;
    background-color: #F56C8C;
    color: #FFFFFF;
    font-family: 'Rubik', sans-serif;
    font-size: 14px;
    font-weight: 500;
    padding: 10px 36px;
    border-radius: 30px;
    text-decoration: none;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(245, 108, 140, 0.35);
    transition: transform 0.2s, box-shadow 0.2s;
  }

  .survey-box-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(245, 108, 140, 0.45);
  }
}

/* Quotes */
.quotes-section {
  background-color: #ffeef4;
  position: relative;
  overflow: hidden;
  padding: 60px 0;

  .quotes-container {
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    padding: 0 15px;
  }
  
  .bg-decoration {
    position: absolute;
    z-index: 0;
    pointer-events: none;
    
    &.left-deco {
      left: 0;
      top: 10%;
      width: 20%;
      max-width: 300px;
    }
    
    &.right-deco {
      right: 0;
      top: 15%;
      width: 20%;
      max-width: 300px;
    }
  }
  
  .heading-img {
    max-width: 500px;
    width: 100%;
    position: relative;
    z-index: 1;
  }

  /* Replace heading image with styled text */
  .heading-text {
    position: relative;
    z-index: 1;
    font-size: 40px; /* match stats title size */
    line-height: 1;
    letter-spacing: 0;
    text-align: center;
    color: #6B6B9C;
  }

  .quotes-grid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    gap: 20px;
    position: relative;
    z-index: 1;
    margin-top: 40px;
  }
  
  .quote-item {
    position: relative;
  }

  /* Specific positioning to match overlapping collage */
  
  .item-1 { /* First Quote - Top Left */
    grid-column: 2 / 8;
    grid-row: 1;
    img {
      width: 105%; /* Smaller */
      max-width: none;
    }
  }
  
  .item-2 { /* Second Quote - Top Right */
    grid-column: 8 / 13;
    grid-row: 1;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    img {
      width: 95%; /* Increased width */
      height: 125px;
      object-fit: fill;
    }
  }
  
  .item-3 { /* Fourth Quote (in DOM order 3) - Right Center */
    grid-column: 5 / 10; /* Moved left more */
    grid-row: 2;
    margin-top: 30px;
    img {
      width: 140%; /* Bigger */
      max-width: none;
    }
  }
  
  .item-4 { /* Third Quote (in DOM order 4) - Bottom Left */
    grid-column: 2 / 8;
    grid-row: 3;
    margin-top: 20px;
    img {
      width: 115%; /* Decreased size */
      max-width: none;
    }
  }

  .footer-text {
    color: #7b6da5;
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 20px;
    position: relative;
    z-index: 1;
  }
  
  .cta-img-btn {
    cursor: pointer;
    transition: transform 0.2s;
    height: 48px;
    width: auto;
    max-width: 100%;
    
    &:hover {
      transform: scale(1.05);
    }
  }
  
  .cta-btn {
    position: relative;
    z-index: 1;
  }
}

@media (max-width: 992px) {
  .quotes-section {
    .quotes-grid {
      display: flex;
      flex-direction: column;
      gap: 30px;
    }
    
    .item-1, .item-2, .item-3, .item-4 {
      grid-column: auto;
      grid-row: auto;
      margin: 0;
      max-width: 100%;
    }
    
    .bg-decoration {
      opacity: 0.3;
    }
  }
}

/* Partners */
.partners-heading {
  font-size: 14px;
  font-weight: 600;
  color: #7b6da5;
}

.partners-grid-layout {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  row-gap: 40px;
  align-items: center;
  justify-items: center;
  width: 100%;
}

.partner-cell {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.partner-logo {
  max-height: 130px;
  max-width: 100%;
  width: auto;
  object-fit: contain;
  transition: all 0.2s;
  
  &:hover {
    transform: scale(1.05);
  }
}

@media (max-width: 992px) {
  .partners-grid-layout {
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }
}

@media (max-width: 576px) {
  .partners-grid-layout {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

/* Mobile Optimizations */
@media (max-width: 768px) {
  /* Shared size for stats “ИЗТЕГЛИ ДОКЛАДА” + app-support “Свали приложението” on /survey only */
  .report-view {
    --survey-stats-cta-w: min(300px, calc(100vw - 72px));
    --survey-stats-cta-h: 48px;
    /* Quotes download image: slightly wider than stats pill on mobile */
    --survey-quotes-cta-w: min(320px, calc(100vw - 56px));
  }

  /* Hero Section - Fix background image stretching */
  .hero-banner {
    background-size: cover !important;
    background-position: center center !important;
    min-height: auto;
    padding: 30px 15px;
    border-radius: 20px;
  }
  
  .hero-section .container-fluid {
    padding: 0 15px !important;
  }

  /* Center the hero text block on mobile */
  .hero-content-col {
    padding-left: 0 !important;
    padding-right: 0 !important;
    justify-content: center !important;
    text-align: center;
  }
  
  .hero-content-inner {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 0px;
    margin-top: -8px;
    max-width: 100%;
    box-sizing: border-box;
  }
  
  /* Match hero heading to stats title size on mobile (Щастливите и трудни моменти...) */
  .hero-content-inner h1 {
    font-size: 28px;
    /* Nudge so it sits in the box and fits */
    transform: translateX(-2px);
    max-width: 100%;
  }
  
  /* Let lines wrap so heading fits inside the hero box on mobile */
  .hero-content-inner h1 .fixed-line {
    white-space: normal;
    overflow-wrap: break-word;
  }

  .report-tag {
    font-size: 14px;
  }
  
  .hero-content-inner .description {
    font-size: 16px;
  }
  
  .hero-content-inner .cta-btn {
    padding: 12px 40px;
    font-size: 11px;
    width: 100%;
    max-width: 280px;
  }

  .report-download-btn {
    width: 100%;
    max-width: 360px;
  }

  /* Stats CTA: narrower than default pill on mobile only; height from .report-download-btn */
  .stats-section .stats-bubble > .report-download-btn {
    width: var(--survey-stats-cta-w);
    max-width: var(--survey-stats-cta-w);
    min-width: 0;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
  }

  /* App support “Свали приложението” image: match stats CTA width/height (mobile /survey only) */
  .report-view :deep(.app-support .download-row > a:first-child) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--survey-stats-cta-w);
    max-width: var(--survey-stats-cta-w);
    min-width: 0;
    height: var(--survey-stats-cta-h);
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    overflow: hidden;
  }

  .report-view :deep(.app-support .download-row .download-btn) {
    width: 100%;
    height: 100%;
    max-height: 100%;
    object-fit: contain;
    object-position: center;
  }

  .report-view :deep(.app-support .download-row .report-app-support-cta) {
    width: 100%;
    height: 100%;
    min-height: var(--survey-stats-cta-h);
    box-sizing: border-box;
  }
  
  /* Stats Section - Stack vertically */
  .stats-section {
    padding: 30px 0 2rem;
    
    .stats-bubble {
      padding: 30px 15px 30px 15px;
    }
    
    h2 {
      font-size: 28px;
      margin-bottom: 30px;
    }
    
    .stats-grid {
      display: flex !important;
      flex-direction: column !important;
      gap: 35px !important;
      align-items: center;
    }
    
    .stat-item {
      width: 100% !important;
      max-width: 100% !important;
      flex: 0 0 100% !important;
      margin: 0 auto;
      padding: 0 10px;
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
    }
    
    .stat-value {
      font-size: 48px;
      line-height: 58px;
      margin-bottom: 12px;
    }
    
    .stat-desc {
      font-size: 13px;
      max-width: 280px;
      margin: 0 auto;
    }
    
    .stats-footer {
      font-size: 14px;
      padding: 0 10px;
    }
    
    .stats-footer .footer-line {
      margin-bottom: 10px;
    }
    
    .stats-bubble .cta-btn {
      padding: 12px 50px;
      width: 100%;
      max-width: 280px;
      margin-top: 40px !important;
    }
  }
  
  /* App Support Section - Center phone and stack bubbles */
  /* moved to ReportAppSupportSection.vue */
  
  /* Survey Box Section - mobile only */
  .survey-box-section {
    padding: 24px 16px 28px;
  }

  .survey-box-section .survey-img-wrapper {
    max-width: 100%;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    display: block;
  }

  .survey-box-section .survey-img {
    max-width: 100%;
  }

  .survey-box-section .survey-box-content {
    transform: none;
  }

  .survey-box-section .survey-box-bg {
    padding: 20px 18px 24px;
    border-radius: 28px;
    text-align: center;
  }

  .survey-box-section .survey-box-top-text {
    font-size: 15px;
    line-height: 1.5;
    margin-bottom: 18px;
    text-align: center;
  }

  .survey-box-section .survey-box-highlight {
    white-space: nowrap;
  }

  .survey-box-section .survey-box-card {
    padding: 24px 18px 28px;
    border-radius: 28px;
    text-align: center;
  }

  .survey-box-section .survey-box-heading {
    font-size: 19px;
    margin-bottom: 16px;
    text-align: center;
    line-height: 1.35;
  }

  .survey-box-section .survey-box-body {
    font-size: 14px;
    line-height: 1.55;
    text-align: center;
    margin-bottom: 12px;
  }

  .survey-box-section .survey-box-body:last-of-type {
    margin-bottom: 20px;
  }

  .survey-box-section .survey-box-btn {
    font-size: 14px;
    padding: 12px 28px;
    display: block;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }
  
  /* Quotes Section */
  .quotes-section {
    padding: 40px 15px;
    
    .heading-img {
      max-width: 100%;
      margin-bottom: 30px;
    }

    .heading-text {
      font-size: 28px; /* match stats title size on mobile */
      margin-bottom: 30px;
    }
    
    .quotes-grid {
      display: flex !important;
      flex-direction: column !important;
      gap: 25px !important;
      align-items: center !important;
    }
    
    .quote-item {
      width: 100% !important;
      max-width: 100% !important;
      display: flex !important;
      justify-content: center !important;
      margin: 0 !important;
      
      img {
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        object-fit: contain !important;
      }
    }
    
    .item-1 {
      grid-column: auto !important;
      grid-row: auto !important;
      margin-top: 0 !important;
      width: 100% !important;
      
      img {
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        object-fit: contain !important;
        transform: scale(1.2);
      }
    }
    
    .item-2 {
      grid-column: auto !important;
      grid-row: auto !important;
      margin-top: 0 !important;
      width: 100% !important;
      
      img {
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        object-fit: contain !important;
        transform: scale(0.92);
      }
    }
    
    .item-3,
    .item-4 {
      grid-column: auto !important;
      grid-row: auto !important;
      margin-top: 0 !important;
      width: 100% !important;
      
      img {
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        object-fit: contain !important;
        transform: scale(1.2);
      }
    }
    
    .footer-text {
      font-size: 14px;
      padding: 0 10px;
    }
    
    /* Slightly wider than stats pill; height unchanged */
    .cta-img-btn {
      width: var(--survey-quotes-cta-w);
      max-width: var(--survey-quotes-cta-w);
      height: var(--survey-stats-cta-h);
      min-height: var(--survey-stats-cta-h);
      object-fit: contain;
      object-position: center;
      display: block;
      margin-left: auto;
      margin-right: auto;
      box-sizing: border-box;
    }
  }
  
  /* Partners Section */
  .partners-section {
    padding: 30px 15px;
    
    .partners-heading {
      font-size: 13px;
      margin-bottom: 30px;
    }
  }
}

@media (max-width: 992px) {
  .hero {
    text-align: center;
    h1 { font-size: 32px; }
    h2 { font-size: 24px; }
  }
  
  .stats-grid {
    gap: 30px 0;
  }
}
</style>

